export class ResourceHelper {
  constructor() {
    this.source = {};
  }

  declareResources(res) {
    this.source = {
      ...this.source,
      ...res,
    };
  }

  get(name) {
    return this.source[name];
  }

  getDeclaredResources(resources) {
    return resources.reduce((acc, { name }) => {
      if (this.has(name)) {
        acc[name] = this.get(name);
      }
      return acc;
    }, {});
  }

  filter(resources) {
    return Object.values(
      resources.reduce((acc, res) => {
        const { name } = res;
        acc[name] = res;
        return acc;
      }, {}),
    ).filter(({ name }) => !this.has(name));
  }

  has(name) {
    return this.source.hasOwnProperty(name);
  }
}

export const resourceHelper = new ResourceHelper();
